type Props = {
  message: string
  onClose: () => void
}

const RescheduleNotAllowed = ({ message, onClose }: Props) => {
  return (
    <div className="text-center py-6">
      <div className="mb-4">
        <svg
          className="mx-auto h-12 w-12 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <h3 className="text-xl font-medium text-gray-900 mb-2">
        Reschedule not allowed
      </h3>
      <p className="text-base text-gray-600 mb-4">{message}</p>
      <button
        onClick={onClose}
        className="inline-flex items-center px-4 py-2 border border-transparent font-medium rounded-md text-white bg-orange hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
      >
        Close
      </button>
    </div>
  )
}

export default RescheduleNotAllowed
